require('./history.jade')

HistoryDirective = (SelectClubSearchService) ->
  restrict: "A"
  replace: false
  templateUrl: "score-registration/select-club/history.jade"
  scope:
    selectClub: '&onClubSelected'
  link: (scope) ->
    scope.loadClub = (page) ->
      SelectClubSearchService.getPlayedClubs page: page

HistoryDirective.$inject = ["SelectClubSearchService"]

module.exports = HistoryDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/score-registration/select-club/history-directive.coffee